import { Pipe, PipeTransform } from '@angular/core';

import { CommentaryTypeEnum } from '@enums/commentary-type.enum';
import { Commentary } from '@models/commentary';

@Pipe({
  name: 'commentariesGroupByType',
  standalone: true
})
export class CommentariesGroupByTypePipe implements PipeTransform {
  transform(commentaries: Commentary[], type: CommentaryTypeEnum): Commentary {
    return (commentaries ?? []).find(commentary => commentary.type === type);
  }
}
